import { __rest } from "tslib";
import React, { useState } from "react";
import { StyledButton } from "./styles";
import { FaDownload } from "react-icons/fa";
import { Spinner } from "../../Spinner/styles";
var DownloadButton = function (_a) {
    var onClick = _a.onClick, text = _a.text, fixed = _a.fixed, iconSize = _a.iconSize, textStyle = _a.textStyle, buttonWidth = _a.buttonWidth, icon = _a.icon, isLoading = _a.isLoading, disabled = _a.disabled, color = _a.color, rest = __rest(_a, ["onClick", "text", "fixed", "iconSize", "textStyle", "buttonWidth", "icon", "isLoading", "disabled", "color"]);
    var _b = useState(false), expanded = _b[0], setExpanded = _b[1];
    var customExpanded = fixed === "open" ? true : fixed === "closed" ? false : expanded;
    return (React.createElement(StyledButton, { style: rest, buttonWidth: buttonWidth, customColor: color, expanded: customExpanded, onMouseEnter: function () { return setExpanded(true); }, onMouseLeave: function () { return setExpanded(false); }, disabled: disabled || isLoading, onClick: function (e) {
            onClick(e);
        } }, isLoading ? (React.createElement("div", { style: {
            width: customExpanded ? (buttonWidth || 85) + 17 : 17,
            display: "flex",
            justifyContent: "center"
        } },
        React.createElement(Spinner, { inverted: true, background: disabled || isLoading ? "#666" : color, size: 10 }))) : (React.createElement(React.Fragment, null,
        icon ? icon : React.createElement(FaDownload, { size: iconSize || 12 }),
        React.createElement("span", { style: textStyle }, text || "Download")))));
};
DownloadButton.defaultProps = {
    text: "Download",
    onClick: function () { },
    fixed: undefined,
    iconSize: 12,
    textStyle: {},
    buttonWidth: 85,
    icon: React.createElement(FaDownload, { size: 12 }),
    color: "#2ec9b7",
    isLoading: false,
    disabled: false
};
export default DownloadButton;
//# sourceMappingURL=index.js.map